import { FC, Fragment, useState } from 'react';
import FRMCustomerLegalDocument from './CustomerPage.Legal.Document';
import { Alert, Tabs } from 'antd';
import FleetTitle from '@/libs/antd/components/Title';
import FRMCustomerLegalManager from './CustomerPage.Legal.Manager';
import FRMCustomerLegalShareholder from './CustomerPage.Legal.Shareholder';
import { useFRMCustomerPage } from './CustomerPage';

const FRMCustomerLegal: FC<{
	onSubmit: () => void;
}> = ({ onSubmit }) => {
	const [activeTabKey, setActiveTabKey] = useState<string>('manager');
	const { totalShareholding, validationStatus } = useFRMCustomerPage();

	return (
		<Fragment>
			<FRMCustomerLegalDocument />

			<div style={{ height: 40 }} />
			<FleetTitle>Management/Shareholder Listing</FleetTitle>

			<Alert
				message={
					<>
						Pastikan data seluruh pengurus dan pemegang saham sudah lengkap dan
						terbaru.
					</>
				}
				type="warning"
				className="custom-alert"
				showIcon
				style={{ marginBottom: 20 }}
			/>

			{!validationStatus?.management && (
				<Alert
					message={<>Wajib input minimal 1 pengurus</>}
					type="warning"
					className="custom-alert"
					showIcon
					style={{ marginBottom: 20 }}
				/>
			)}
			{totalShareholding !== 100 && (
				<Alert
					message={
						totalShareholding < 100
							? 'Jika total kepemilikan saham tidak mencapai 100%, tidak bisa melanjutkan di tahap request SLIK'
							: 'Total kepemilikan saham melebihi 100%, mohon cek kembali'
					}
					type="warning"
					className="custom-alert"
					showIcon
					style={{ marginBottom: 20 }}
				/>
			)}

			<Tabs
				activeKey={activeTabKey}
				onChange={(key) => setActiveTabKey(key)}
				items={[
					{
						key: 'manager',
						label: 'Pengurus',
						children: (
							<FRMCustomerLegalManager
								onSubmit={() => setActiveTabKey('shareholder')}
							/>
						),
					},
					{
						key: 'shareholder',
						label: 'Pemegang Saham',
						children: <FRMCustomerLegalShareholder onSubmit={onSubmit} />,
					},
				]}
			/>
		</Fragment>
	);
};

export default FRMCustomerLegal;
